import React from 'react';
import {t} from '@lingui/core/macro';

import {MonitorStatusBadge} from 'entities/monitor';
import OpenLinkNewWindow from 'shared/ui/IconButton/OpenLinkNewWindow/OpenLinkNewWindow';
import {IHttpMonitorItem} from 'features/http/model/HttpMonitor/IHttpMonitor';

import GeoStatusBanner from './GeoStatusBanner/GeoStatusBanner';
import GeoStatusCard from './GeoStatusCard/GeoStatusCard';
import {getGeoStatusState} from './geoStatusState';

import styles from './GeoStatus.module.scss';

interface IGeoStatusProps {
    item: IHttpMonitorItem;
}

const GeoStatus: React.FC<IGeoStatusProps> = ({item}) => {
    const state = getGeoStatusState(item);

    return (
        <div className={styles.container}>
            <GeoStatusBanner item={item} state={state} />
            <span className={styles.url}>
                URL: <OpenLinkNewWindow url={item.url_human_readable} styleText={styles.link} />
            </span>
            <span className={styles.monitoring}>
                {t`Мониторинг`}: <MonitorStatusBadge status={item.status} />
            </span>
            <GeoStatusCard item={item} state={state} />
        </div>
    );
};

export default GeoStatus;
